import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import type { SourcesFilters } from "@/types";
import { buildSourcesUrlParams, parseSourcesFilters, parseSourcesPage } from "@/utils/sourcesFilters.ts";

/** The Sources filters, sort and page, held in the URL. A change replaces the history entry. */
export function useSourcesFilters() {
  const [params, setParams] = useSearchParams();
  const filters = useMemo(() => parseSourcesFilters(params), [params]);
  const page = parseSourcesPage(params);
  const setFilters = useCallback(
    (next: SourcesFilters) => setParams(buildSourcesUrlParams(next, 0), { replace: true }),
    [setParams],
  );
  const setPage = useCallback(
    (next: number) => setParams(buildSourcesUrlParams(filters, next), { replace: true }),
    [filters, setParams],
  );
  return { filters, page, setFilters, setPage };
}
